import LOGO from '../assets/images/logo.svg';
import HELP_CIRCLE from '../assets/images/help-circle.svg';
import USER_IMAGE from '../assets/images/user.png';
import CIRCLE_TICK from '../assets/images/tick-circle.svg';
import WELCOME_ILLUSTRATOR from '../assets/images/illustration.svg';
import SUCCESS_GIF from '../assets/images/aa.gif';
import CALENDAR from '../assets/images/calendar.svg';
import CHECK from '../assets/images/check-tick.svg';
import CHECK_TICK from '../assets/images/tick-square.svg';
import CHECK_RED from '../assets/images/tick-square-red.svg';
// import CHECK_TICK_RED from '../assets/images/check-tick-red.svg'
import ATTACHMENT from '../assets/images/attachment.svg';
import UNREAD_NOTIFICATION from '../assets/images/unread-notification.svg';
import PUSH_NOTIFICATION from '../assets/images/push-notification.svg';
import PDF from '../assets/images/pdf.png';
import EXCEL from '../assets/images/excel.png';
import WARNING from '../assets/images/warning.svg';
import CLOSE from '../assets/images/close.svg';
import LOADING from '../assets/images/loading.svg';
import DASHBOARD from '../assets/images/dashboard.svg';
import DASHBOARD_ACTIVE from '../assets/images/dashboard-active.svg';
import ORDERS from '../assets/images/orders.svg';
import ORDERS_ACTIVE from '../assets/images/orders-active.svg';
import VENDOR from '../assets/images/shop.svg';
import VENDOR_ACTIVE from '../assets/images/shop-active.svg';
import STATIC_CONTENT from '../assets/images/static-content.svg';
import STATIC_CONTENT_ACTIVE from '../assets/images/static-content-active.svg';
import FINANCIALS from '../assets/images/moneys.svg';
import FINANCIALS_ACTIVE from '../assets/images/moneys-active.svg';
import NOTIFICATION from '../assets/images/admin-notification.svg';
import NOTIFICATION_ACTIVE from '../assets/images/admin-notification-active.svg';
import BANNER from '../assets/images/gallery.svg';
import BANNER_ACTIVE from '../assets/images/gallery-active.svg';
import CLIENTS from '../assets/images/clients.svg';
import CHATS from '../assets/images/message.svg';
import CHATS_ACTIVE from '../assets/images/message-active.svg';
import CLIENTS_ACTIVE from '../assets/images/clients-active.svg';
import USER from '../assets/images/people.svg';
import USER_ACTIVE from '../assets/images/people-active.svg';
import NO_DATA from '../assets/images/no-data.svg';
import FILTER from '../assets/images/filter-outline.svg';
import FILE_ICON from '../assets/images/file.svg';
import DELETE_IC from '../assets/images/delete.svg';
import IMAGE_IC from '../assets/images/image_ic.svg';
import VIDEO_IC from '../assets/images/video.svg';
import VIDEO_IC_ACTIVE from '../assets/images/videoActive.svg';
import CANCEL_CIRCLE from '../assets/images/cancel-circle.svg';
import NO_DATA_FOUND from '../assets/images/no-data-found.svg';
import EDIT_IC from '../assets/images/edit-ic.svg';
import TRASH from '../assets/images/trash.svg';
import ADMIN_BG from '../assets/images/admin.png';
import LOGO_WHITE from '../assets/images/logo-white.svg';
import SUCCESS_IC from '../assets/images/success-ic.svg';
import ERROR_IC from '../assets/images/error-ic.svg';
import NO_RECORD_FOUND from '../assets/images/Illustrations.svg';
import PRODUCTION from '../assets/images/produnction.svg';
import PRODUCTION_ACTIVE from '../assets/images/produnction-active.svg';
import IMAGE_PLACEHOLDER from '../assets/images/image-placeholder.png';
import VISSIBILITY from '../assets/images/vissibility.svg';
import VISSIBILITY_OFF from '../assets/images/vissibility-off.svg';
import CLOSE_CIRCLE from '../assets/images/close-circle.svg';
import ARROW_DOWN from '../assets/images/arrow-down.svg';
import INFO_ICON from '../assets/images/info-icon.svg';
import ROLES from '../assets/images/roles.svg';
import ROLES_ACTIVE from '../assets/images/roles-active.svg';
import INFO_ICON_LIGHT from '../assets/images/info-icon-light.svg';
import DOCUMENT from '../assets/images/document.svg';
import QUESTION from '../assets/images/question.svg';
import REQUEST from '../assets/images/request.svg';
import REQUEST_ACTIVE from '../assets/images/request-active.svg';
import TICK_CIRCLE from '../assets/images/tick-circle-white.svg';
import PRODUCT_LIBRARY from '../assets/images/product-library.svg';
import PRODUCT_LIBRARY_ACTIVE from '../assets/images/product-library-active.svg';
import MAP_PIN from '../assets/images/map_pin.svg';
import CHECL_CTA from '../assets/images/check-cta.svg';
import CLOSE_CTA from '../assets/images/close-cta.svg';
import SEARCH from '../assets/images/search.svg';
import SEARCH_BLACK from '../assets/images/search-black.svg';
import CHAT from '../assets/images/chat.svg';
import DOWNLOAD_FILE from '../assets/images/download-file.svg';
import VENDOR_PLACEHOLDER from '../assets/images/vendor-placeholder.png';
import LOADER_TWO from '../assets/images/loader-2.gif';
import IC_CAMERA from '../assets/images/ic-camera.svg';
import IC_DOCUMENT from '../assets/images/ic-document.svg';
import IC_VIDEO from '../assets/images/ic-video.svg';
import IC_MEDIA from '../assets/images/ic-media.svg';
import SINGLE_TICK from '../assets/images/single-check.svg';
import DOUBLE_TICK from '../assets/images/double-check.svg';
import DOUBLE_TICK_UNREAD from '../assets/images/double-check-unread.svg';
import ONLINE from '../assets/images/online.svg';
import SEND from '../assets/images/send.svg';
import SORT from '../assets/images/sort.svg';
import SORT_ASCENDING from '../assets/images/ascending.svg';
import SORT_DESCENDING from '../assets/images/descending.svg';
import BLOCK_ICON from '../assets/images/block-icon.svg';
import VIEW from '../assets/images/view.svg';
import BELL from '../assets/images/notification-bing.svg';
import BELL_WHITE from '../assets/images/notification-white.svg';
import NO_NOTIFICATIONS from '../assets/images/no-notifications.svg';
import COMISSIONS from '../assets/images/commission.svg';
import COMISSIONS_ACTIVE from '../assets/images/commission-active.svg';
import CHIP_DELETE from '../assets/images/chip-delete.svg';

import PRODUCTIONS_BG from '../assets/images/web/production_bg.png';
import LOCATIONS_BG from '../assets/images/web/locations_bg.png';
import ORDERS_BG from '../assets/images/web/orders_bg.png';
import SETS_BG from '../assets/images/web/sets_bg.png';
import TOTAL_ORDERS from '../assets/images/web/total-orders.svg';
import TOTAL_PRODUCTIONS from '../assets/images/web/total-production.svg';
import TOTAL_LOCATIONS from '../assets/images/web/total-locations.svg';
import TOTAL_SETS from '../assets/images/web/total-sets.svg';
import SPENDING_BY_PRODUCTION from '../assets/images/web/spending-by-production.svg';
import ASSOCIATED_WITH from '../assets/images/web/associated-with.svg';
import UPDATES_IC from '../assets/images/web/updates_ic.svg';
import detailsImg from '../assets/images/detail-img.png';
import DP from '../assets/images/dp.png';
import DP1 from '../assets/images/dp2.png';
import dep1 from '../assets/images/department1.png';
import dep2 from '../assets/images/department2.png';
import Marker from '../assets/images/Marker.svg';
import SLIDE_PREV from '../assets/images/slidePrev.svg';
import SLIDE_NEXT from '../assets/images/slideNext.svg';
import homeBanner from '../assets/images/banner-bg.png';
import homeImg from '../assets/images/home-img.png';
import AmzLogo from '../assets/images/amazon-logo.png';
import WBlogo from '../assets/images/wb-logo.png';
import UniLogo from '../assets/images/uni-logo.png';
import ArrowImg from '../assets/images/arrow-img.svg';
import About1 from '../assets/images/about1.png';
import About2 from '../assets/images/about2.png';
import About3 from '../assets/images/about3.png';
import About4 from '../assets/images/about4.png';
import MilestoneImg from '../assets/images/mlestone-img.png';
import SETS_BLUE from '../assets/images/web/sets-blue.svg';
import ImageIcon from '../assets/images/icons/img-icon.svg';
import PdfIcon from '../assets/images/icons/pdf-icon.svg';
import DocIcon from '../assets/images/icons/document-icon.svg';
import Image_Placegolder from '../assets/images/admin-placeholder.png';
import Nbc from '../assets/images/nbc.png';
import Bet from '../assets/images/bet.png';
import Netflix from '../assets/images/netflix.png';
import Sony from '../assets/images/sony.png';
import Showtime from '../assets/images/showtime.png';
import Hulu from '../assets/images/hulu.png';
import Marvel from '../assets/images/marvel.png';
import ColumbiaImg from '../assets/images/columbia-img.png';
import UniImg from '../assets/images/uni-img.png';
import ParamountImg from '../assets/images/paraount-img.png';
import WbImg from '../assets/images/wb-img.png';
import AppImg from '../assets/images/app.png';
import AppStore from '../assets/images/AppStore.png';
import PlayStore from '../assets/images/PlayStore.png';
import Arrow_Up from '../assets/images/arrow-up.svg';
import Trash_Grey from '../assets/images/trash-grey.svg';
import Selected from '../assets/images/selected.svg';
import Edit_White from '../assets/images/web/edit-white.svg';
import Plus_White from '../assets/images/web/plus-white.svg';
import EPISODE_MENU_IC from '../assets/images/web/episode-ic.svg';
import EPISODE_MENU_IC_SELECTED from '../assets/images/web/episode-ic-selected.svg';
import UNCHECK_BLACK from '../assets/images/web/tick-square-black.svg';
import CALL from '../assets/images/call.svg';
import EMAIL from '../assets/images/email.svg';
import HEADQUARTERS from '../assets/images/headquarter.svg';
import ADD_CIRCLE from '../assets/images/web/add-circle.svg';
import RISK_IC from '../assets/images/web/risk-ic.svg';
import STORE_IC from '../assets/images/store-icon.svg';
import ORDER_IC from '../assets/images/order-icon.svg';
import EDIT_BLACK from '../assets/images/icons/edit-icon.svg';
import BookBanner from '../assets/images/book-banner.png';
import NO_INTERNET from '../assets/images/under-development.svg';
import guardIcon from '../assets/images/icons/guard-icon.svg';
import talentIcon from '../assets/images/icons/talent-icon.svg';
import studioIcon from '../assets/images/icons/studio-icon.svg';
import ipIcon from '../assets/images/icons/ip-icon.svg';
import UserBackground from '../assets/images/user-background.svg';
import LogoWhite from '../assets/images/logo-white.svg';
import CalendarIcon from '../assets/images/icons/calendar-icon.svg';
import CalendarSearchIcon from '../assets/images/icons/calendar-search-icon.svg';
import ArrowLeft from '../assets/images/web/arrow-left.svg';
import ArrowRight from '../assets/images/web/arrow-right.svg';
import Plus_Ic from '../assets/images/icons/plus-icon.svg';
import Minus_Ic from '../assets/images/icons/minus-icon.svg';
import View_Shifts from '../assets/images/web/view-shifts.svg';
import Active_Advisor from '../assets/images/web/active_advisor.png';
import Active_Events_Ic from '../assets/images/web/active-events-ic.svg';
import Active_Advisor_Ic from '../assets/images/web/active_advisor-ic.svg';
import DownLoad_File_black from '../assets/images/download-file-black.svg';
import Check_Circle_Outlined from '../assets/images/check-circle-outlined.svg';
import Check_Circle_Filled from '../assets/images/check-circle-filled.svg';
import Production_Menu_Image from '../assets/images/prod-menu-image.png';
import Arrow_Down_White from '../assets/images/arrow-down-white.svg';
import Location_Ic from '../assets/images/location-ic.svg';
import Location_Pin_Ic from '../assets/images/location-pin-ic.svg';
import Current_Location_Ic from '../assets/images/current-location-ic.svg';
import Add_Ic from '../assets/images/add-ic.svg';
import PinIcon from '../assets/images/pin-icon.svg';
import Assign_Progress from '../assets/images/black-car.svg';
import Active_Sets_Ic from '../assets/images/web/active-sets-ic.svg';
import Active_Orders_Ic from '../assets/images/web/active-orders-ic.svg';
import Active_Crew_members_Ic from '../assets/images/web/active-members-ic.svg';
import Active_Documents_Ic from '../assets/images/web/active-documents-ic.svg';
import Active_Locations_Ic from '../assets/images/web/active-location-ic.svg';
import Locations_Ic from '../assets/images/web/locations-ic.svg';
import Empty_Cart from '../assets/images/web/empty-cart.svg';
import Pickup_Map_Ic from '../assets/images/web/pickup-map-ic.svg';
import Drop_Map_Ic from '../assets/images/web/drop-map-ic.svg';
import Truck_Icon_Ic from '../assets/images/icons/truck-icon.svg';
import Sucess_Ic from '../assets/images/web/sucess.svg';
import More_Ic from '../assets/images/web/more-ic.svg';
import Edit_Blue_ic from '../assets/images/web/edit-blue-ic.svg';
import Ad_img from '../assets/images/ad-img.png';
import RequestIcon from '../assets/images/request-icon.svg';
import MessageIcon from '../assets/images/message-icon.svg';
import CostTracking from '../assets/images/cost-tracking.png';
import Video_Play_Ic from '../assets/images/web/video-play-ic.svg';
import UploadIcon from '../assets/images/upload-icon.svg';
import StoreBanner from '../assets/images/store-banner.png';
import LogoNew from '../assets/images/logoImg.svg';
import AppImgs from '../assets/images/app-imgs.png';
import NewBanner from '../assets/images/new-banner.png';
import ChatBubbleIcon from '../assets/images/chat-bubble.svg';
import Production_ic from '../assets/images/web/production_ic.svg';
import Order_ic from '../assets/images/web/order_ic.svg';
import Setbg from '../assets/images/setbg.png';
import Productionbg from '../assets/images/productionbg.png';
import Orderbg from '../assets/images/orderbg.png';
import Locationbg from '../assets/images/locationbg.png';
import VendorDetail from '../assets/images/VendorDetail.png';
import episodebg from '../assets/images/episodebg.png';
import Documentbg from '../assets/images/documentbg.png';
import Crewbg from '../assets/images/crewbg.png';
import Security_Ic from '../assets/images/icons/security-icon.svg';
import Safety_Ic from '../assets/images/icons/safety-icon.svg';
import Order_Icon from '../assets/images/icons/order-white-icon.svg';
import LINK from '../assets/images/link.png';
import Plus_Icon from '../assets/images/web/plus.svg';
import ExploreProducts from '../assets/images/explore-products.svg';
import CreateProduction from '../assets/images/create-production.svg';
import AllDepartment from '../assets/images/Camera.png';
import DocumentIcon from '../assets/images/document-icon.svg';
import ScheduleIcon from '../assets/images/schedule-icon.svg';
import ScheduleIconActive from '../assets/images/schedule-active-icon.svg';
import ChatIcon from '../assets/images/icons/chat-new-icon.svg';
import GROUP_PLACEHOLDER from '../assets/images/groupPlaceholder.png';
// import DummyPdf from '../assets/images/dummy.pdf'
// import AppStore from '../assets/images/App-Store.png'
// import PlayStore from '../assets/images/Play-Store.png'

import ReelTrakLogo from '../assets/images/reeltrak-logo.svg';
import UserDummy from '../assets/images/user-dummy.svg';

import FAQ_ILLUSTRATOR from '../assets/images/faq-illustrator.svg';
import ViewShiftIcon from '../assets/images/icons/view-shift-icon.svg';
import TrackIcon from '../assets/images/icons/track-icon.svg';
import CancelIcon from '../assets/images/icons/cancel-icon.svg';
import OrderSideIcon from '../assets/images/icons/order-side-icon.svg';
import AcceptIcon from '../assets/images/icons/accept-order.svg';
import FinanceIcon from '../assets/images/icons/finance-icon.svg';
import InvoiceIcon from '../assets/images/icons/invoice-icon.svg';
import NotesIcon from '../assets/images/icons/notes-icon.svg';
import SuccessTick from '../assets/images/icons/success-tick.svg';
import PaymentSuccess from '../assets/images/payment-success.svg';
import PaymentFailed from '../assets/images/payment-failed.svg';
import logoImage from '../assets/images/web/adminLogo.png';
import PaymentIcon from '../assets/images/icons/payment-icon.svg';

import CameraDept from '../assets/images/cameradept.png';
import CinemaDept from '../assets/images/cinemadept.png';
import AudioDept from '../assets/images/audiodept.png';
import LightDept from '../assets/images/lightdept.png';
import StudioDept from '../assets/images/studiodept.png';
import InvoiceIconBlue from '../assets/images/icons/InvoiceIconBlue.svg';
import VendorPlaceholder from '../assets/images/vendor-placeholder.png';
import FileWhiteIcon from '../assets/images/icons/file-white-icon.svg';
import ArrowUp from '../assets/images/icons/up-arrow-icon.svg';
import DownloadWhiteIcon from '../assets/images/icons/download-white-icon.svg';
import PageSmIcon from '../assets/images/icons/page-sm-icon.svg';
import PageSmWhiteIcon from '../assets/images/icons/page-sm-white-icon.svg';
import UrgentSmIcon from '../assets/images/icons/urgent-sm-white-icon.svg';
import SORTLOCATION from '../assets/images/SortLocation.svg';
import SORTLOCATIONDECREASE from '../assets/images/SortLocationDecrease.svg';
import SORTLOCATIONINCREASE from '../assets/images/SortLocationIncrease.svg';
import PIN_MESSAGE from '../assets/images/PinMessage.svg';
import Event_IC from '../assets/images/icons/events-icon.svg';
import Activity_IC from '../assets/images/icons/activity.svg';
import TransferOwnershipIcon from '../assets/images/TransferOwnership.svg';
import EPISODE_GROUP_IC from '../assets/images/episode-group-ic.svg';
import SET_GROUP_IC from '../assets/images/set-group-ic.svg';
import CALENDER_GROUP_IC from '../assets/images/calender-group-ic.svg';

const STATIC_IMAGES: any = process.env.STATIC_IMAGES || {};

const Images = {
  AUTH_BG_1: STATIC_IMAGES.AUTH_BG_1 || '',
  AUTH_BG_2: STATIC_IMAGES.AUTH_BG_2 || '',
  AUTH_BG_3: STATIC_IMAGES.AUTH_BG_3 || '',
  AUTH_BG_4: STATIC_IMAGES.AUTH_BG_4 || '',
  AUTH_BG_5: STATIC_IMAGES.AUTH_BG_5 || '',
  AUTH_BG_6: STATIC_IMAGES.AUTH_BG_6 || '',
  AUTH_BG_7: STATIC_IMAGES.AUTH_BG_7 || '',
  AUTH_BG_8: STATIC_IMAGES.AUTH_BG_8 || '',
  AUTH_BG_9: STATIC_IMAGES.AUTH_BG_9 || '',
  AUTH_BG_10: STATIC_IMAGES.AUTH_BG_10 || '',
  SLIDE_NEXT,
  SLIDE_PREV,
  VIDEO_IC_ACTIVE,
  LOADER_TWO,
  LOGO,
  HELP_CIRCLE,
  USER_IMAGE,
  CIRCLE_TICK,
  WELCOME_ILLUSTRATOR,
  SUCCESS_GIF,
  CALENDAR,
  CHECK,
  CHECK_TICK,
  ATTACHMENT,
  WARNING,
  CLOSE,
  CHECK_RED,
  CHATS,
  CHATS_ACTIVE,
  // CHECK_TICK_RED,
  LOADING,
  DASHBOARD,
  DASHBOARD_ACTIVE,
  ORDERS,
  ORDERS_ACTIVE,
  VENDOR,
  VENDOR_ACTIVE,
  STATIC_CONTENT,
  STATIC_CONTENT_ACTIVE,
  FINANCIALS,
  EXCEL,
  FINANCIALS_ACTIVE,
  NOTIFICATION,
  NOTIFICATION_ACTIVE,
  BANNER,
  BANNER_ACTIVE,
  CLIENTS,
  CLIENTS_ACTIVE,
  USER,
  USER_ACTIVE,
  NO_DATA,
  FILTER,
  FILE_ICON,
  DELETE_IC,
  IMAGE_IC,
  VIDEO_IC,
  NO_DATA_FOUND,
  EDIT_IC,
  TRASH,
  ADMIN_BG,
  LOGO_WHITE,
  SUCCESS_IC,
  ERROR_IC,
  NO_RECORD_FOUND,
  PRODUCTION,
  NO_INTERNET,
  PDF,
  PRODUCTION_ACTIVE,
  IMAGE_PLACEHOLDER,
  VISSIBILITY,
  VISSIBILITY_OFF,
  CLOSE_CIRCLE,
  CANCEL_CIRCLE,
  ARROW_DOWN,
  INFO_ICON,
  ROLES,
  ROLES_ACTIVE,
  INFO_ICON_LIGHT,
  DOCUMENT,
  LINK,
  QUESTION,
  REQUEST,
  REQUEST_ACTIVE,
  TICK_CIRCLE,
  PRODUCT_LIBRARY,
  PRODUCT_LIBRARY_ACTIVE,
  NO_NOTIFICATIONS,
  MAP_PIN,
  CHECL_CTA,
  CLOSE_CTA,
  SEARCH,
  SEARCH_BLACK,
  CHAT,
  DOWNLOAD_FILE,
  VENDOR_PLACEHOLDER,
  IC_CAMERA,
  IC_DOCUMENT,
  IC_VIDEO,
  IC_MEDIA,
  SINGLE_TICK,
  DOUBLE_TICK,
  DOUBLE_TICK_UNREAD,
  ONLINE,
  SEND,
  SORT,
  SORT_ASCENDING,
  SORT_DESCENDING,
  FAQ_ILLUSTRATOR,
  BLOCK_ICON,
  VIEW,
  BELL_WHITE,
  BELL,
  COMISSIONS,
  COMISSIONS_ACTIVE,
  CHIP_DELETE,
  UNREAD_NOTIFICATION,
  PUSH_NOTIFICATION,

  PRODUCTIONS_BG,
  LOCATIONS_BG,
  ORDERS_BG,
  SETS_BG,
  TOTAL_LOCATIONS,
  TOTAL_ORDERS,
  TOTAL_PRODUCTIONS,
  TOTAL_SETS,
  SPENDING_BY_PRODUCTION,
  ASSOCIATED_WITH,
  UPDATES_IC,
  detailsImg,
  DP,
  DP1,
  dep1,
  dep2,
  Marker,
  STATIC_IMAGES,
  homeBanner,
  homeImg,
  AmzLogo,
  WBlogo,
  UniLogo,
  ArrowImg,
  About1,
  About2,
  About3,
  About4,
  MilestoneImg,
  SETS_BLUE,
  ImageIcon,
  PdfIcon,
  DocIcon,
  Image_Placegolder,
  Nbc,
  Bet,
  Netflix,
  Sony,
  Showtime,
  Hulu,
  Marvel,
  ColumbiaImg,
  UniImg,
  ParamountImg,
  WbImg,
  AppImg,
  AppStore,
  PlayStore,
  Arrow_Up,
  Trash_Grey,
  Selected,
  Edit_White,
  Plus_White,
  EPISODE_MENU_IC,
  EPISODE_MENU_IC_SELECTED,
  UNCHECK_BLACK,
  CALL,
  EMAIL,
  HEADQUARTERS,
  ADD_CIRCLE,
  RISK_IC,
  ORDER_IC,
  STORE_IC,
  EDIT_BLACK,
  BookBanner,
  guardIcon,
  talentIcon,
  studioIcon,
  ipIcon,
  UserBackground,
  LogoWhite,
  CalendarIcon,
  ArrowLeft,
  ArrowRight,
  Plus_Ic,
  Minus_Ic,
  View_Shifts,
  Active_Advisor,
  Active_Events_Ic,
  Active_Advisor_Ic,
  DownLoad_File_black,
  Check_Circle_Outlined,
  Check_Circle_Filled,
  Production_Menu_Image,
  Arrow_Down_White,
  Location_Ic,
  Location_Pin_Ic,
  Current_Location_Ic,
  Add_Ic,
  PinIcon,
  Assign_Progress,
  Active_Sets_Ic,
  Active_Orders_Ic,
  Active_Crew_members_Ic,
  Active_Documents_Ic,
  Active_Locations_Ic,
  Locations_Ic,
  Empty_Cart,
  Pickup_Map_Ic,
  Drop_Map_Ic,
  Truck_Icon_Ic,
  Sucess_Ic,
  More_Ic,
  Edit_Blue_ic,
  Ad_img,
  RequestIcon,
  MessageIcon,
  CostTracking,
  Video_Play_Ic,
  UploadIcon,
  StoreBanner,
  LogoNew,
  AppImgs,
  NewBanner,
  ChatBubbleIcon,
  Production_ic,
  Order_ic,
  // DummyPdf,
  //  AppStore,
  //  PlayStore,
  Setbg,
  Productionbg,
  Orderbg,
  Locationbg,
  episodebg,
  Documentbg,
  Crewbg,
  Security_Ic,
  Safety_Ic,
  Order_Icon,
  Plus_Icon,
  ExploreProducts,
  CreateProduction,
  ReelTrakLogo,
  AllDepartment,
  VendorDetail,
  DocumentIcon,
  ScheduleIcon,
  FinanceIcon,
  InvoiceIcon,
  ScheduleIconActive,
  UserDummy,
  ChatIcon,
  GROUP_PLACEHOLDER,
  ViewShiftIcon,
  TrackIcon,
  CancelIcon,
  AcceptIcon,
  OrderSideIcon,
  NotesIcon,
  SuccessTick,
  PaymentSuccess,
  PaymentFailed,
  logoImage,
  PaymentIcon,
  CameraDept,
  CinemaDept,
  AudioDept,
  LightDept,
  StudioDept,
  InvoiceIconBlue,
  VendorPlaceholder,
  FileWhiteIcon,
  ArrowUp,
  DownloadWhiteIcon,
  PageSmIcon,
  PageSmWhiteIcon,
  UrgentSmIcon,
  SORTLOCATION,
  SORTLOCATIONDECREASE,
  SORTLOCATIONINCREASE,
  PIN_MESSAGE,
  Event_IC,
  Activity_IC,
  TransferOwnershipIcon,
  CalendarSearchIcon,
  EPISODE_GROUP_IC,
  SET_GROUP_IC,
  CALENDER_GROUP_IC,
};

export default Images;
